import type { AdminDirectoryUser } from "@/features/administration/api/administration.api";
import { LEGACY_ORG_ROLE } from "@/utils/roles";

type ResetLinkTarget = Pick<AdminDirectoryUser, "id" | "role" | "status" | "isOwner">;

/**
 * People-row offer for POST /admin/users/:userId/reset-link.
 * Hidden when the server will refuse: yourself, any owner, an admin targeting
 * another admin, or a person who is not an active member. An owner may still
 * offer the action for an admin.
 */
export function canOfferSendResetLink(input: {
  callerId: string | null | undefined;
  callerIsOwner: boolean;
  target: ResetLinkTarget;
}): boolean {
  if (!input.callerId || input.target.id === input.callerId) return false;
  if (input.target.isOwner || input.target.role === LEGACY_ORG_ROLE.OWNER) return false;
  if (input.target.status !== "active") return false;
  if (input.target.role === LEGACY_ORG_ROLE.ADMIN && !input.callerIsOwner) return false;
  return true;
}
